// =============================================================================
// MÜLAKAT HAZIRLIK MERKEZİ - MODÜL YAPISI
// =============================================================================

export const interviewModules = [
  {
    id: 1,
    module_id: 1,
    title: 'Mülakat Temelleri',
    subtitle: 'Mülakat süreci, CV, giyim kuşam, beden dili',
    icon: '📋',
    color: 'from-blue-500 to-indigo-600',
    totalUnits: 4,
    estimatedTime: 35,
    units: [
      { 
        id: 1, 
        title: 'Mülakat Süreci', 
        lessons: [
          { lesson_id: 'INT-M1-U1-L1', title: 'Mülakat Süreci Nasıl İşler?', xp: 30 },
          { lesson_id: 'INT-M1-U1-L2', title: 'Online Video Mülakat', xp: 35 }
        ]
      },
      { 
        id: 2, 
        title: 'CV Hazırlama', 
        lessons: [
          { lesson_id: 'INT-M1-U2-L1', title: 'CV Hazırlama Rehberi', xp: 30 }
        ]
      },
      { 
        id: 3, 
        title: 'Giyim Kuşam', 
        lessons: [
          { lesson_id: 'INT-M1-U3-L1', title: 'Giyim Kuşam - Kadın', xp: 25 },
          { lesson_id: 'INT-M1-U3-L2', title: 'Giyim Kuşam - Erkek', xp: 25 }
        ]
      },
      { 
        id: 4, 
        title: 'Beden Dili', 
        lessons: [
          { lesson_id: 'INT-M1-U4-L1', title: 'Beden Dili ve Duruş', xp: 35 },
          { lesson_id: 'INT-M1-U4-L2', title: 'Beden Dili Senaryoları', xp: 30 }
        ]
      }
    ]
  },
  {
    id: 2,
    module_id: 2,
    title: 'Grup Mülakatı Teknikleri',
    subtitle: 'Grup dinamikleri, takım oyunları, öne çıkma',
    icon: '👥',
    color: 'from-emerald-500 to-teal-600',
    totalUnits: 3,
    estimatedTime: 30,
    units: [
      { 
        id: 1, 
        title: 'Grup Mülakatı Temelleri', 
        lessons: [
          { lesson_id: 'INT-M2-U1-L1', title: 'Grup Mülakatı Nedir?', xp: 30 },
          { lesson_id: 'INT-M2-U1-L2', title: 'Grup Dinamikleri', xp: 35 }
        ]
      },
      { 
        id: 2, 
        title: 'Takım Aktiviteleri', 
        lessons: [
          { lesson_id: 'INT-M2-U2-L1', title: 'Takım Oyunları', xp: 35 },
          { lesson_id: 'INT-M2-U2-L2', title: 'Ada Senaryosu Simülasyonu', xp: 40 }
        ]
      },
      { 
        id: 3, 
        title: 'Öne Çıkma', 
        lessons: [
          { lesson_id: 'INT-M2-U3-L1', title: 'Öne Çıkma Stratejileri', xp: 35 }
        ]
      }
    ]
  },
  {
    id: 3,
    module_id: 3,
    title: 'Birebir Mülakat Hazırlık',
    subtitle: 'STAR tekniği, sık sorular, zor sorular',
    icon: '🎯',
    color: 'from-purple-500 to-pink-600',
    totalUnits: 3,
    estimatedTime: 35,
    units: [
      { 
        id: 1, 
        title: 'Mülakat Yapısı', 
        lessons: [
          { lesson_id: 'INT-M3-U1-L1', title: 'Birebir Mülakat Yapısı', xp: 30 },
          { lesson_id: 'INT-M3-U1-L2', title: 'STAR Tekniği', xp: 40 }
        ]
      },
      { 
        id: 2, 
        title: 'Temel Sorular', 
        lessons: [
          { lesson_id: 'INT-M3-U2-L1', title: 'Kendinizi Tanıtın', xp: 35 },
          { lesson_id: 'INT-M3-U2-L2', title: 'Zor Sorular', xp: 40 }
        ]
      },
      { 
        id: 3, 
        title: 'Sık Sorulan Sorular', 
        lessons: [
          { lesson_id: 'INT-M3-U3-L1', title: 'Sık Sorulan Sorular Quiz', xp: 50 }
        ]
      }
    ]
  },
  {
    id: 4,
    module_id: 4,
    title: 'THY Mülakat Rehberi',
    subtitle: 'Türk Hava Yolları mülakat süreci ve soruları',
    icon: '🇹🇷',
    color: 'from-red-500 to-rose-600',
    totalUnits: 3,
    estimatedTime: 40,
    units: [
      { 
        id: 1, 
        title: 'THY Süreci', 
        lessons: [
          { lesson_id: 'INT-M4-U1-L1', title: 'THY Mülakat Süreci', xp: 40 },
          { lesson_id: 'INT-M4-U1-L2', title: 'THY\'nin Aradığı Özellikler', xp: 35 }
        ]
      },
      { 
        id: 2, 
        title: 'THY Soruları', 
        lessons: [
          { lesson_id: 'INT-M4-U2-L1', title: 'THY Video Mülakat Soruları', xp: 40 },
          { lesson_id: 'INT-M4-U2-L2', title: 'THY Senaryo Soruları', xp: 40 }
        ]
      },
      { 
        id: 3, 
        title: 'THY Kurul Mülakatı', 
        lessons: [
          { lesson_id: 'INT-M4-U3-L1', title: 'THY Kurul Mülakatı Quiz', xp: 45 }
        ]
      }
    ]
  },
  {
    id: 5,
    module_id: 5,
    title: 'Pegasus Mülakat Rehberi',
    subtitle: 'Pegasus Airlines mülakat süreci ve soruları',
    icon: '🟡',
    color: 'from-yellow-500 to-orange-500',
    totalUnits: 2,
    estimatedTime: 25,
    units: [
      { 
        id: 1, 
        title: 'Pegasus Süreci', 
        lessons: [
          { lesson_id: 'INT-M5-U1-L1', title: 'Pegasus Mülakat Süreci', xp: 35 },
          { lesson_id: 'INT-M5-U1-L2', title: 'Pegasus Sık Sorulan Sorular', xp: 35 }
        ]
      },
      { 
        id: 2, 
        title: 'Pegasus Senaryolar', 
        lessons: [
          { lesson_id: 'INT-M5-U2-L1', title: 'Pegasus Senaryo Soruları', xp: 40 }
        ]
      }
    ]
  },
  {
    id: 6,
    module_id: 6,
    title: 'SunExpress Mülakat Rehberi',
    subtitle: 'SunExpress mülakat süreci ve soruları',
    icon: '☀️',
    color: 'from-amber-400 to-yellow-500',
    totalUnits: 2,
    estimatedTime: 20,
    units: [
      { 
        id: 1, 
        title: 'SunExpress Süreci', 
        lessons: [
          { lesson_id: 'INT-M6-U1-L1', title: 'SunExpress Mülakat Süreci', xp: 35 }
        ]
      },
      { 
        id: 2, 
        title: 'SunExpress Soruları', 
        lessons: [
          { lesson_id: 'INT-M6-U1-L2', title: 'SunExpress Sık Sorulan Sorular', xp: 40 }
        ]
      }
    ]
  },
  {
    id: 7,
    module_id: 7,
    title: 'Yabancı Havayolları',
    subtitle: 'Emirates, Qatar Airways ve diğerleri',
    icon: '🌍',
    color: 'from-sky-500 to-blue-600',
    totalUnits: 3,
    estimatedTime: 35,
    units: [
      { 
        id: 1, 
        title: 'Emirates', 
        lessons: [
          { lesson_id: 'INT-M7-U1-L1', title: 'Emirates Mülakat Rehberi', xp: 45 },
          { lesson_id: 'INT-M7-U1-L2', title: 'Emirates Sık Sorulan Sorular', xp: 40 }
        ]
      },
      { 
        id: 2, 
        title: 'Qatar Airways', 
        lessons: [
          { lesson_id: 'INT-M7-U2-L1', title: 'Qatar Airways Mülakat Rehberi', xp: 40 }
        ]
      },
      { 
        id: 3, 
        title: 'Diğer Havayolları', 
        lessons: [
          { lesson_id: 'INT-M7-U3-L1', title: 'AnadoluJet, Corendon ve Diğerleri', xp: 35 }
        ]
      }
    ]
  }
];

export const getInterviewModule = (moduleId) => {
  return interviewModules.find(m => m.id === parseInt(moduleId) || m.module_id === parseInt(moduleId));
};

export default interviewModules;
